// extracted by mini-css-extract-plugin
module.exports = {"payment-form":"Stripe_payment-form__1bRff","form":"Stripe_form__1Rb7A","payment-icons":"Stripe_payment-icons__3Dnq5","payment-form__cancel":"Stripe_payment-form__cancel__2R2DW"};